import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { Fund } from '@Types';
import { useCallback } from 'react';

export const useGetFundData = () => {
  const [fetch, response] = useRequest<Fund>();

  const getFundData = useCallback(
    (fundId: number, accessCode?: string | null) =>
      fetch(API.paths.fund(fundId, accessCode), 'get'),

    [fetch],
  );

  return [getFundData, response] as const;
};
